<template>
  <div class="document bg-blue-grey-1 text-blue-grey-6 flex-center flex column">
    <span class="type">{{ type.toUpperCase() }}</span>
  </div>
</template>

<script>
/**
 * Display a circle with a file extension
 */
export default {
  props: {
    // File extension (etc: jpg, png, pdf, docx)
    type: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.document {
  border-radius: 100%;
  width: 40px;
  height: 40px;
  box-shadow: $shadow-1;

  span {
    display: block;

    &.type {
      padding-top:2px;
      line-height: 1em;
      font-size:1em;
      font-weight:500;
    }
  }
}
</style>
